var React = require('react');

function DottedCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1033 8949c110.45695 0 200-89.54305 200-200s-89.54305-200-200-200-200 89.54305-200 200 89.54305 200 200 200z","fill":"none","stroke":"#21478d","strokeDasharray":"2 13","strokeLinejoin":"round","transform":"translate(-832 -8548)"}));
}

DottedCircle.defaultProps = {"height":"402","viewBox":"0 0 402 402","width":"402"};

module.exports = DottedCircle;

DottedCircle.default = DottedCircle;
